import Oidc, { UserManagerSettings, WebStorageStateStore } from "oidc-client";
import { AppSettings } from "../configuration/appsettings";
import BetterClockService from "./clock-service";

const debug_level = parseInt(AppSettings.IDENTITY_DEBUG_LEVEL);

if (debug_level) {
  Oidc.Log.level = debug_level;
}

Oidc.Log.logger = console;

const baseUrl = `${window.location.protocol}//${window.location.hostname}${
  window.location.port ? `:${window.location.port}` : ""
}`;

export enum OidcEndpoints {
  LOGIN = "oidc-callback",
  RENEW = "oidc-renew",
  SWITCH_ACCOUNTS = "switch-accounts",
}

const clockService = new BetterClockService(`${baseUrl}/time`, AppSettings);

const OpenIdSettings = {
  client_id: AppSettings.IDENTITY_CLIENT_ID,
  redirect_uri: `${baseUrl}/${OidcEndpoints.LOGIN}`,
  response_type: "code",
  scope: AppSettings.IDENTITY_SCOPES,
  authority: AppSettings.IDENTITY_URL,
  silent_redirect_uri: `${baseUrl}/${OidcEndpoints.RENEW}`,
  automaticSilentRenew: true,
  filterProtocolClaims: true,
  loadUserInfo: true,
  post_logout_redirect_uri: `${AppSettings.LEGACY_CD_URL}/logout`,
  userStore: new WebStorageStateStore({ store: localStorage }),
  clockService: clockService,
  accessTokenExpiringNotificationTime: AppSettings.REFRESH_TIME,
} as UserManagerSettings;

export default OpenIdSettings;
